import request from '@/utils/request'

export function getProductList (data) {
  return request({
    url: '/api/v1/products',
    method: 'POST',
    data
  })
}
